import N8nInputLabel from './InputLabel.vue';

export default N8nInputLabel;
